/* ================================================================
   Product Image Hotspots — click tracking + debug measure tool
   ================================================================ */
(function () {
  'use strict';

  /* ─── 4-platform tracker (GA4 / Meta / TikTok / Klaviyo) ─── */
  function track(name, params) {
    params = params || {};
    try { if (window.gtag) window.gtag('event', name, params); } catch (_) {}
    try { if (window.fbq) window.fbq('trackCustom', name, params); } catch (_) {}
    try { if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track(name, params); } catch (_) {}
    try { if (window._learnq) window._learnq.push(['track', name, params]); } catch (_) {}
  }

  /* ─── Hotspot click → fire event + let browser follow href ─── */
  document.addEventListener('click', function (e) {
    var spot = e.target.closest('.dmf-pih__spot');
    if (!spot) return;
    track('product_hotspot_click', {
      product_handle: spot.getAttribute('data-product-handle'),
      product_title: spot.getAttribute('data-product-title'),
      label: spot.getAttribute('data-label'),
      section_label: spot.getAttribute('data-section-label') || '',
      destination: spot.getAttribute('href')
    });
  }, { passive: true });

  /* ─── Debug mode — ?hotspot-debug=1 ─── */
  function initDebug() {
    var qs = new URLSearchParams(location.search);
    if (qs.get('hotspot-debug') !== '1') return;

    var sections = document.querySelectorAll('.dmf-pih');
    if (!sections.length) return;

    sections.forEach(function (sec) {
      sec.classList.add('is-debug');
      var pic = sec.querySelector('.dmf-pih__pic');
      if (!pic) return;

      var dragStart = null;
      var box = sec.querySelector('.dmf-pih__measure');
      if (!box) {
        box = document.createElement('div');
        box.className = 'dmf-pih__measure';
        box.innerHTML = '<strong>HOTSPOT DEBUG</strong>이미지 위에서 마우스 드래그 → 영역 좌표 측정<br><code>idle</code>';
        document.body.appendChild(box);
      }
      var codeEl = box.querySelector('code');

      function pctFromEvent(e) {
        var rect = pic.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width * 100;
        var y = (e.clientY - rect.top) / rect.height * 100;
        return { x: Math.max(0, Math.min(100, x)), y: Math.max(0, Math.min(100, y)) };
      }

      function fmtRange(top, left, w, h) {
        return 'top:    ' + top.toFixed(1)  + '%\n'
             + 'left:   ' + left.toFixed(1) + '%\n'
             + 'width:  ' + w.toFixed(1)    + '%\n'
             + 'height: ' + h.toFixed(1)    + '%';
      }

      pic.addEventListener('mousemove', function (e) {
        var p = pctFromEvent(e);
        if (dragStart) {
          var top  = Math.min(dragStart.y, p.y);
          var left = Math.min(dragStart.x, p.x);
          var w    = Math.abs(p.x - dragStart.x);
          var h    = Math.abs(p.y - dragStart.y);
          codeEl.textContent = fmtRange(top, left, w, h);
        } else {
          codeEl.textContent = 'x: ' + p.x.toFixed(1) + '%\ny: ' + p.y.toFixed(1) + '%';
        }
      });
      pic.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        dragStart = pctFromEvent(e);
      });
      document.addEventListener('mouseup', function (e) {
        if (!dragStart) return;
        var p = pctFromEvent(e);
        var top  = Math.min(dragStart.y, p.y);
        var left = Math.min(dragStart.x, p.x);
        var w    = Math.abs(p.x - dragStart.x);
        var h    = Math.abs(p.y - dragStart.y);
        var formatted = fmtRange(top, left, w, h);
        codeEl.textContent = formatted;
        try { console.log('[HOTSPOT]\n' + formatted); } catch (_) {}
        dragStart = null;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDebug);
  } else {
    initDebug();
  }

  /* ─── Drag-drop edit mode (?hotspot-edit=1) ─── */
  function initEdit() {
    var qs = new URLSearchParams(location.search);
    if (qs.get('hotspot-edit') !== '1') return;

    var sections = document.querySelectorAll('.dmf-pih');
    if (!sections.length) return;

    sections.forEach(function (sec) {
      sec.classList.add('is-edit');
      sec.classList.remove('is-debug'); /* edit 모드가 debug 모드 override */
      var pic = sec.querySelector('.dmf-pih__pic');
      if (!pic) return;

      var spots = Array.from(sec.querySelectorAll('.dmf-pih__spot'));
      var changes = {}; /* label → updated coords */

      /* 각 spot 에 4 corner resize handle 추가 */
      spots.forEach(function (spot) {
        ['tl', 'tr', 'bl', 'br'].forEach(function (c) {
          var h = document.createElement('span');
          h.className = 'dmf-pih__handle ' + c;
          h.dataset.corner = c;
          spot.appendChild(h);
        });
      });

      /* Edit panel UI — 정밀 편집 */
      var box = document.createElement('div');
      box.className = 'dmf-pih__edit-box';
      box.innerHTML =
        '<h3>HOTSPOT EDIT — 정밀</h3>' +
        '<div class="desc">목록 또는 이미지에서 hotspot 클릭 → 선택. 드래그/리사이즈 또는 input 직접 입력. 변경 후 "Copy JSON" → 채팅에 붙여 넣어주세요.</div>' +
        '<div class="selected-info"><strong>선택된 hotspot 없음</strong><code>아래 목록 또는 이미지에서 클릭</code></div>' +
        '<div class="input-grid" style="display:none">' +
          '<div class="input-field"><label>Top</label><input type="number" data-coord="top" step="0.1" /><span class="unit">%</span></div>' +
          '<div class="input-field"><label>Left</label><input type="number" data-coord="left" step="0.1" /><span class="unit">%</span></div>' +
          '<div class="input-field"><label>Width</label><input type="number" data-coord="width" step="0.1" /><span class="unit">%</span></div>' +
          '<div class="input-field"><label>Height</label><input type="number" data-coord="height" step="0.1" /><span class="unit">%</span></div>' +
        '</div>' +
        '<div class="keyboard-hint">' +
          '<kbd>↑↓←→</kbd> 0.1% 이동 · ' +
          '<kbd>Shift</kbd>+화살표 = 1% · ' +
          '<kbd>Alt</kbd>+화살표 = 리사이즈 · ' +
          '<kbd>Esc</kbd> = 선택 해제' +
        '</div>' +
        '<details open><summary>22 Hotspot 목록</summary><div class="hotspot-list"></div></details>' +
        '<div class="btn-row">' +
          '<button class="copy-btn">Copy 변경분</button>' +
          '<button class="secondary copy-all-btn">Copy ALL</button>' +
        '</div>' +
        '<details><summary>JSON 미리보기</summary><div class="json-area"></div></details>';
      document.body.appendChild(box);
      var info = box.querySelector('.selected-info');
      var jsonArea = box.querySelector('.json-area');
      var copyBtn = box.querySelector('.copy-btn');
      var copyAllBtn = box.querySelector('.copy-all-btn');
      var inputGrid = box.querySelector('.input-grid');
      var coordInputs = {
        top: box.querySelector('input[data-coord="top"]'),
        left: box.querySelector('input[data-coord="left"]'),
        width: box.querySelector('input[data-coord="width"]'),
        height: box.querySelector('input[data-coord="height"]')
      };
      var hotspotList = box.querySelector('.hotspot-list');

      /* 22 hotspot 목록 build */
      spots.forEach(function(spot, i){
        var item = document.createElement('div');
        item.className = 'dmf-pih__edit-box hotspot-list-item';
        item.removeAttribute('class');
        item.className = 'hotspot-list-item';
        item.dataset.spotIdx = i;
        item.innerHTML =
          '<span class="idx">' + String(i+1).padStart(2, '0') + '</span>' +
          '<span class="name">' + (spot.getAttribute('data-label') || '?') + '</span>';
        item.addEventListener('click', function(){ selectSpot(spot); });
        hotspotList.appendChild(item);
      });

      /* 좌표 % 계산 */
      function pctFromSpot(spot) {
        var picRect = pic.getBoundingClientRect();
        var r = spot.getBoundingClientRect();
        return {
          top: ((r.top - picRect.top) / picRect.height) * 100,
          left: ((r.left - picRect.left) / picRect.width) * 100,
          width: (r.width / picRect.width) * 100,
          height: (r.height / picRect.height) * 100
        };
      }

      function snapshotSpot(spot) {
        var p = pctFromSpot(spot);
        var label = spot.getAttribute('data-label');
        changes[label] = {
          handle: spot.getAttribute('data-product-handle'),
          label: label,
          top: +p.top.toFixed(1),
          left: +p.left.toFixed(1),
          width: +p.width.toFixed(1),
          height: +p.height.toFixed(1)
        };
        updateJsonArea();
        updateSelectedInfo(spot);
      }

      function updateSelectedInfo(spot) {
        var p = pctFromSpot(spot);
        var label = spot.getAttribute('data-label');
        info.innerHTML =
          '<strong>' + label + '</strong>' +
          '<code>' +
            'top:    ' + p.top.toFixed(2) + '%\n' +
            'left:   ' + p.left.toFixed(2) + '%\n' +
            'width:  ' + p.width.toFixed(2) + '%\n' +
            'height: ' + p.height.toFixed(2) + '%' +
          '</code>';
        /* 4 input 값 동기화 (수동 입력 안 중일 때만) */
        if (document.activeElement && document.activeElement.dataset && document.activeElement.dataset.coord) {
          /* 사용자가 input 편집 중이면 덮어쓰기 안 함 */
        } else {
          coordInputs.top.value    = p.top.toFixed(2);
          coordInputs.left.value   = p.left.toFixed(2);
          coordInputs.width.value  = p.width.toFixed(2);
          coordInputs.height.value = p.height.toFixed(2);
        }
        inputGrid.style.display = 'grid';
        /* hotspot list 활성화 표시 */
        Array.from(hotspotList.querySelectorAll('.hotspot-list-item')).forEach(function(it){ it.classList.remove('active'); });
        var idx = spots.indexOf(spot);
        var active = hotspotList.querySelector('[data-spot-idx="' + idx + '"]');
        if (active) {
          active.classList.add('active');
          /* scroll into view */
          active.scrollIntoView({ block: 'nearest' });
        }
      }

      /* input 으로 직접 좌표 설정 */
      function applyCoords(spot, top, left, width, height) {
        top = Math.max(0, Math.min(100, top));
        left = Math.max(0, Math.min(100, left));
        width = Math.max(0.5, Math.min(100, width));
        height = Math.max(0.5, Math.min(100, height));
        spot.style.setProperty('--top-d', top + '%');
        spot.style.setProperty('--left-d', left + '%');
        spot.style.setProperty('--w-d', width + '%');
        spot.style.setProperty('--h-d', height + '%');
        spot.style.setProperty('--top-m', top + '%');
        spot.style.setProperty('--left-m', left + '%');
        spot.style.setProperty('--w-m', width + '%');
        spot.style.setProperty('--h-m', height + '%');
        snapshotSpot(spot);
      }

      ['top','left','width','height'].forEach(function(key){
        coordInputs[key].addEventListener('input', function(){
          if (!selected) return;
          var top    = parseFloat(coordInputs.top.value)    || 0;
          var left   = parseFloat(coordInputs.left.value)   || 0;
          var width  = parseFloat(coordInputs.width.value)  || 10;
          var height = parseFloat(coordInputs.height.value) || 5;
          applyCoords(selected, top, left, width, height);
        });
      });

      function updateJsonArea() {
        var arr = Object.values(changes);
        if (!arr.length) { jsonArea.textContent = ''; return; }
        jsonArea.textContent = JSON.stringify(arr, null, 2);
      }

      function snapshotAll() {
        return spots.map(function (s) {
          var p = pctFromSpot(s);
          return {
            handle: s.getAttribute('data-product-handle'),
            label: s.getAttribute('data-label'),
            top: +p.top.toFixed(1),
            left: +p.left.toFixed(1),
            width: +p.width.toFixed(1),
            height: +p.height.toFixed(1)
          };
        });
      }

      function copyText(t, btn) {
        var done = function () {
          var orig = btn.textContent;
          btn.classList.add('copied');
          btn.textContent = 'Copied! ✓';
          setTimeout(function () { btn.classList.remove('copied'); btn.textContent = orig; }, 1800);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(t).then(done).catch(function () {
            var ta = document.createElement('textarea');
            ta.value = t; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); done();
          });
        } else {
          var ta = document.createElement('textarea');
          ta.value = t; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); done();
        }
      }

      copyBtn.addEventListener('click', function () {
        var t = jsonArea.textContent || '[]';
        copyText(t, copyBtn);
      });
      copyAllBtn.addEventListener('click', function () {
        copyText(JSON.stringify(snapshotAll(), null, 2), copyAllBtn);
      });

      /* 선택 + 드래그 + 리사이즈 통합 핸들러 (Pointer Events) */
      var selected = null;
      var dragging = false;
      var resizing = null; /* 'tl' | 'tr' | 'bl' | 'br' */
      var startX, startY, startTop, startLeft, startW, startH;

      function selectSpot(spot) {
        if (selected) selected.classList.remove('is-selected');
        selected = spot;
        spot.classList.add('is-selected');
        updateSelectedInfo(spot);
      }

      sec.addEventListener('pointerdown', function (e) {
        var handle = e.target.closest('.dmf-pih__handle');
        var spot = e.target.closest('.dmf-pih__spot');
        if (!spot) return;
        e.preventDefault();
        selectSpot(spot);

        var picRect = pic.getBoundingClientRect();
        startX = e.clientX; startY = e.clientY;
        var r = spot.getBoundingClientRect();
        startTop = r.top - picRect.top;
        startLeft = r.left - picRect.left;
        startW = r.width;
        startH = r.height;

        if (handle) {
          resizing = handle.dataset.corner;
          dragging = false;
        } else {
          dragging = true;
          resizing = null;
          spot.classList.add('is-dragging');
        }
        try { spot.setPointerCapture(e.pointerId); } catch (_) {}
      }, true);

      sec.addEventListener('pointermove', function (e) {
        if (!selected || (!dragging && !resizing)) return;
        e.preventDefault();
        var picRect = pic.getBoundingClientRect();
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        var newTop = startTop, newLeft = startLeft, newW = startW, newH = startH;

        if (dragging) {
          newTop = startTop + dy;
          newLeft = startLeft + dx;
        } else if (resizing) {
          /* corner-based resize */
          if (resizing === 'tl') { newTop = startTop + dy; newLeft = startLeft + dx; newW = startW - dx; newH = startH - dy; }
          else if (resizing === 'tr') { newTop = startTop + dy; newW = startW + dx; newH = startH - dy; }
          else if (resizing === 'bl') { newLeft = startLeft + dx; newW = startW - dx; newH = startH + dy; }
          else if (resizing === 'br') { newW = startW + dx; newH = startH + dy; }
          newW = Math.max(20, newW); newH = Math.max(20, newH);
        }
        /* boundary clamp */
        newTop = Math.max(0, Math.min(picRect.height - newH, newTop));
        newLeft = Math.max(0, Math.min(picRect.width - newW, newLeft));

        var topPct = (newTop / picRect.height) * 100;
        var leftPct = (newLeft / picRect.width) * 100;
        var wPct = (newW / picRect.width) * 100;
        var hPct = (newH / picRect.height) * 100;
        selected.style.setProperty('--top-d', topPct + '%');
        selected.style.setProperty('--left-d', leftPct + '%');
        selected.style.setProperty('--w-d', wPct + '%');
        selected.style.setProperty('--h-d', hPct + '%');
        selected.style.setProperty('--top-m', topPct + '%');
        selected.style.setProperty('--left-m', leftPct + '%');
        selected.style.setProperty('--w-m', wPct + '%');
        selected.style.setProperty('--h-m', hPct + '%');
        updateSelectedInfo(selected);
      }, true);

      function endDrag(e) {
        if (!selected) return;
        if (dragging || resizing) {
          snapshotSpot(selected);
          selected.classList.remove('is-dragging');
        }
        dragging = false; resizing = null;
        try { selected.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      sec.addEventListener('pointerup', endDrag, true);
      sec.addEventListener('pointercancel', endDrag, true);

      /* href click 무효화 (edit 모드 동안 page 이동 막기) */
      sec.addEventListener('click', function (e) {
        if (e.target.closest('.dmf-pih__spot')) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* 키보드 화살표 미세조정 */
      document.addEventListener('keydown', function(e){
        if (!selected) return;
        /* input 편집 중일 때는 화살표 = input spinner — 그냥 둠 */
        if (e.target && e.target.tagName === 'INPUT') return;

        if (e.key === 'Escape') {
          selected.classList.remove('is-selected');
          selected = null;
          inputGrid.style.display = 'none';
          info.innerHTML = '<strong>선택된 hotspot 없음</strong><code>아래 목록 또는 이미지에서 클릭</code>';
          Array.from(hotspotList.querySelectorAll('.hotspot-list-item')).forEach(function(it){ it.classList.remove('active'); });
          return;
        }

        if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].indexOf(e.key) === -1) return;
        e.preventDefault();

        /* step 결정: Shift = 1%, default = 0.1% */
        var step = e.shiftKey ? 1.0 : 0.1;
        var resize = e.altKey;  /* Alt = resize 모드 */

        var p = pctFromSpot(selected);
        var top = p.top, left = p.left, width = p.width, height = p.height;

        if (resize) {
          /* width / height 조절 */
          if (e.key === 'ArrowLeft')  width  -= step;
          if (e.key === 'ArrowRight') width  += step;
          if (e.key === 'ArrowUp')    height -= step;
          if (e.key === 'ArrowDown')  height += step;
        } else {
          /* 이동 */
          if (e.key === 'ArrowLeft')  left -= step;
          if (e.key === 'ArrowRight') left += step;
          if (e.key === 'ArrowUp')    top  -= step;
          if (e.key === 'ArrowDown')  top  += step;
        }
        applyCoords(selected, top, left, width, height);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEdit);
  } else {
    initEdit();
  }
})();
